export default __webpack_public_path__ + "d86f7d2b19cd032d981bb30dd99bac86.png";